'use strict';
var React = require('react');
var findDOMNode = require('react-dom').findDOMNode;

var ScrollNavigationBar = React.createClass({
    getInitialState: function () {
        return {
            loaded: false,
            vSize: 0,
            vPosition: 0,
            hSize: 0,
            hPosition: 0
        };
    },
    onScroll: function() {
        this.onUpdate();
    },
    onUpdate: function() {
        var node = findDOMNode(this.refs.content);
        this.setState({
            vSize: node.offsetHeight / node.scrollHeight,
            vPosition: node.scrollTop / node.scrollHeight,
            hSize: node.offsetWidth / node.scrollWidth,
            hPosition: node.scrollLeft / node.scrollWidth,
            loaded: true
        });
    },
    onMouseMove: function(e) {
        var node = findDOMNode(this.refs.content);
        var delta, newPosition;
        if (this.direction === 'vertical') {
            delta = (e.pageY - this.start) / node.offsetHeight;
            newPosition = Math.min(Math.max(0, this.startPosition + delta), this.max);
            node.scrollTop = node.scrollHeight * newPosition;
        } else {
            delta = (e.pageX - this.start) / node.offsetWidth;
            newPosition = Math.min(Math.max(0, this.startPosition + delta), this.max);
            node.scrollLeft = node.scrollWidth * newPosition;
        }
        e.stopPropagation();
        e.preventDefault();
    },
    onMouseUp: function(e) {
        document.body.removeEventListener('mousemove', this.onMouseMove);
        document.body.removeEventListener('mouseup', this.onMouseUp);
        e.stopPropagation();
        e.preventDefault();
    },
    onVerticalThumbMouseDown: function(e) {
        this.direction = 'vertical';
        var node = findDOMNode(this.refs.content);
        this.start = e.pageY;
        this.startPosition = this.state.vPosition;
        this.max = (node.scrollHeight - node.offsetHeight) / node.scrollHeight;
        document.body.addEventListener('mousemove', this.onMouseMove);
        document.body.addEventListener('mouseup', this.onMouseUp);
        e.stopPropagation();
        e.preventDefault();
    },
    onHorizontalThumbMouseDown: function(e) {
        this.direction = 'horizontal';
        var node = findDOMNode(this.refs.content);
        this.start = e.pageX;
        this.startPosition = this.state.hPosition;
        this.max = (node.scrollWidth - node.offsetWidth) / node.scrollWidth;
        document.body.addEventListener('mousemove', this.onMouseMove);
        document.body.addEventListener('mouseup', this.onMouseUp);
        e.stopPropagation();
        e.preventDefault();
    },
    verticalThumbStyle: function(){
        return {
            height: this.state.vSize * 100 + '%',
            top: this.state.vPosition * 100 + '%',
            display: this.state.vSize < 1 && this.state.vSize > 0 && this.state.loaded ? 'block' : 'none'
        }
    },
    horizontalThumbStyle: function(){
        return {
            width: this.state.hSize * 100 + '%',
            left: this.state.hPosition * 100 + '%',
            display: this.state.hSize < 1 && this.state.hSize > 0 && this.state.loaded ? 'block' : 'none'
        };
    },
    componentDidMount: function() {
        var self = this;
        setTimeout(function () {
            self.onUpdate();
        }, 200);
    },
    componentWillReceiveProps: function(nextProps) {

    },
    render: function () {
        return (
            <div className="scroll-view" onScroll={this.onScroll}>
                <div ref="content" className="scroll-content" style={{overflowX:'auto', overflowY:'auto'}}>
                    {this.props.children}
                </div>
                <div
                    className="track scroll-bar-vertical"
                    onMouseDown={this.onVerticalThumbMouseDown}>
                    <div className="thumb" onMouseDown={this.onBarClick} style={this.verticalThumbStyle()}></div>
                </div>
                <div
                    className="track scroll-bar-horizontal"
                    onMouseDown={this.onHorizontalThumbMouseDown}>
                    <div className="thumb" style={this.horizontalThumbStyle()}></div>
                </div>
            </div>
        );
    }
});

module.exports = ScrollNavigationBar;


// WEBPACK FOOTER //
// ./src/views/ScrollNavigationBar.jsx